import * as React from "react";

const VercelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 32 32"
  >
    <defs>
      <linearGradient
        id="SVGFJYatcgJ"
        x1="1.288"
        x2="1.143"
        y1="32.55"
        y2="32.75"
        gradientTransform="matrix(114 0 0 -100 -113 3301)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="1"></stop>
      </linearGradient>
    </defs>
    <path
      fill="url(#SVGFJYatcgJ)"
      fillRule="evenodd"
      d="m16 3.719 14 24.562H2z"
    ></path>
  </svg>
);

export default VercelIcon;
